var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0596 0.383331L9.84786 21.5988V29.1314L38.5959 0.383331H31.0596ZM9.84421 17.0938L14.973 11.965V0.383331H0.644531V50.3833L5.93745 45.0904V5.2677H9.84786V17.0938H9.84421Z",
    fill: "#1C2B57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2903 27.2455L9.84473 33.6875V41.2202L16.2903 34.7782L31.8955 50.3834H39.4282L16.3305 27.2857L16.2903 27.2455Z",
    fill: "#209DD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1027 24.9657L50.685 0.383331H43.1524L18.5701 24.9657L43.9877 50.3833H51.5204L26.1027 24.9657Z",
    fill: "#209DD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.11ac31687f2365c2c77765893f36e8ed.svg";
export { ForwardRef as ReactComponent };